// visibilityState.ts
export let isRunningBingoGameActive = false;
export const setRunningBingoGameActive = (value: boolean) => {
  isRunningBingoGameActive = value;
};
